module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "padded"
  }, [_c('h2', [_c('i', {
    staticClass: "fa fa-tachometer-alt"
  }, [_vm._v(" ")]), _c('org-badge'), _vm._v(" Dashboard\n    "), (_vm.org().shortName) ? _c('small', {
    staticClass: "text-info pull-right hidden-sm-and-down"
  }, [_vm._v(_vm._s(_vm.org().name))]) : _vm._e(), _vm._v(" "), (_vm.isSuper() && _vm.alerts > 0) ? _c('el-badge', {
    attrs: {
      "value": _vm.alerts
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-bottom": "1em"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.alertDrawer = true
      }
    }
  }, [_vm._v("New Users")])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-drawer', {
    attrs: {
      "title": "New Users",
      "visible": _vm.alertDrawer,
      "direction": "rtl",
      "size": _vm.isDesktop ? '52.8%' : '74.1%'
    },
    on: {
      "update:visible": function($event) {
        _vm.alertDrawer = $event
      }
    }
  }, [_c('good-table', {
    attrs: {
      "cols": _vm.cols,
      "rows": _vm.rows,
      "compact": "",
      "theme": "polar-bear"
    }
  })], 1), _vm._v(" "), _c('el-menu', {
    attrs: {
      "default-active": "1",
      "mode": "horizontal",
      "unique-opened": true
    },
    on: {
      "select": _vm.onClick
    }
  }, _vm._l((_vm.contents), function(item, index) {
    return (item.visible) ? _c('el-submenu', {
      key: item.key,
      attrs: {
        "index": '' + index
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      class: item.icon ? 'text-warning fa fa-' + item.icon : ''
    }), _vm._v(" "), (_vm.isDesktop) ? _c('b', [_vm._v(_vm._s(item.title))]) : _vm._e()]), _vm._v(" "), _vm._l((item.children), function(sub, ind2) {
      return (sub.visible) ? _c('el-menu-item', {
        key: sub.key,
        attrs: {
          "index": sub.key,
          "disabled": sub.disabled
        }
      }, [_c('i', {
        class: sub.icon ? 'text-muted fa fa-' + sub.icon : ''
      }), _vm._v(" "), _c('span', [_vm._v(_vm._s(sub.title))])]) : _vm._e()
    })], 2) : _vm._e()
  }), 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "padded"
  }, [_c(_vm.comp, {
    tag: "component"
  })], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21047b20"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/Dashboard.vue
// module id = 1455
// module chunks = 0